import type { PageAbstract, PageItem } from '@lighthouse/core'

export function pageTreeToPageList(trees: PageItem[], list: (PageAbstract & { path?: string })[]): (PageAbstract & { path?: string })[] {
    for (const tree of trees) {
        if (tree.type === 'GROUP') {
            pageTreeToPageList(
                tree.children.map(item => ({ ...item, path: tree.path ? `${tree.path}/${tree.name}` : tree.name })),
                list
            )
        } else {
            list.push(tree)
        }
    }
    return list
}

export function pageTreeToFilterPageList(tree: PageItem[], list: PageAbstract[], filter?: (v: PageItem) => boolean): PageAbstract[] {
    for (const item of tree) {
        if (item.type === 'GROUP') {
            pageTreeToPageList(item.children, list)
        } else {
            if (filter ? filter(item) : true) {
                list.push(item)
            }
        }
    }
    return list
}

export function getTreesFloatIds(trees: PageItem[], list: string[]): string[] {
    function getGroupChildIds(tree: PageItem, list: string[]): string[] {
        list.push(tree.id)
        if (tree.type !== 'GROUP') {
            return list
        }
        for (const item of tree.children) {
            if (item.type === 'GROUP') {
                getGroupChildIds(item, list)
            } else {
                list.push(item.id)
            }
        }
        return list
    }

    return trees.reduce((acc, tree) => getGroupChildIds(tree, acc), list)
}

export function pageTreeAddLevel(trees: PageItem[], parentId?: string, level = 0, path = ''): PageItem[] {
    return trees.map(tree => {
        if (tree.type === 'GROUP') {
            const newPath = path ? `${path}/${tree.name}` : tree.name
            return {
                ...tree,
                level,
                parentId,
                children: pageTreeAddLevel(tree.children, tree.id, level + 1, newPath),
                path: newPath
            }
        }
        return { ...tree, level, parentId, path }
    })
}

export function findByPageByTree(trees: PageItem[]) {
    return (id: string): PageItem | undefined => {
        for (const tree of trees) {
            if (tree.id === id) {
                return tree
            }
            if (tree.type === 'GROUP') {
                const find = findByPageByTree(tree.children)(id)
                if (find) {
                    return find
                }
            }
        }
    }
}

export function floatListToTree(trees: PageItem[]): PageItem[] {
    const tree: PageItem[] = []
    let saveIds: string[] = []

    function getChildren(id: string, level = 0): PageItem[] {
        const children = trees.filter(v => v.parentId === id)
        saveIds = [...saveIds, ...children.map(v => v.id)]
        return children.map(item =>
            item.type === 'GROUP'
                ? { ...item, children: getChildren(item.id, level + 1), level: level + 1, path: '' }
                : { ...item, level: level + 1, path: '' }
        )
    }

    for (const item of trees) {
        if (saveIds.includes(item.id)) {
            continue
        }
        if (item.type === 'GROUP') {
            tree.push({ ...item, children: getChildren(item.id), level: 0, path: '' })
            saveIds.push(item.id)
        } else {
            if (!item.parentId) {
                tree.push({ ...item, level: 0, path: '' })
                saveIds.push(item.id)
            }
        }
    }
    return tree
}

export function getPrevPageByTree(trees: PageItem[], id: string): PageItem | undefined {
    let prev: PageItem | undefined
    for (const tree of trees) {
        if (tree.type === 'GROUP') {
            const find = getPrevPageByTree(tree.children, id)
            if (find) {
                return find
            }
        }
        if (tree.id === id) {
            return prev
        }
        prev = tree
    }
}
